import { render, staticRenderFns } from "./CharacterProse.vue?vue&type=template&id=31029b2f&scoped=true&"
import script from "./CharacterProse.vue?vue&type=script&lang=js&"
export * from "./CharacterProse.vue?vue&type=script&lang=js&"
import style0 from "./CharacterProse.vue?vue&type=style&index=0&id=31029b2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31029b2f",
  null
  
)

export default component.exports